import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import {CommonMessages,ClientMessages} from 'src/app/shared/messages/messages.enum';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-contacttype',
  templateUrl: './contacttype.component.html',
  styleUrls: ['./contacttype.component.css']
})
export class ContacttypeComponent extends BaseComponent implements OnInit {
  public contacttypeObj: any = [];
  cp = 1;
  ord = true;
  colname: "Contact type Name";
  text;
  checked = false;

  today: number = Date.now();
  constructor(
    private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService
  ) { 
    super();
  }
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getContacttype();
  }
  getContacttype() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getContacttype().subscribe(data => {
      self.contacttypeObj = data;
      this.ngxSpinnerService.hide();
     // console.log(self.contacttypeObj);
    //  console.log(data);

    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  editContacttype(id) {
    this.router.navigate(['/corporate/newcontacttype'], { queryParams: { contact_type_id: id } });
  }
  deleteContacttype(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delContacttype(obj).subscribe(data => {
            if (data.status) {
              this.getContacttype();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateContacttypeStatus(event, id) {
    let value = event.source.checked;
    let obj = this.contacttypeObj.find(element => {
      if (element.contact_type_id === id) {
        return true;
      }
    });
    obj = obj;
    obj.isactive = value;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', CommonMessages.activeInactiveConfirmation +" '"+ (value? "Active": "Inactive") +"'", 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          let contacttypeObj = {
            isactive: obj.isactive,
            contact_type_id: id
          }
          this.master.updateContacttypeStatus(contacttypeObj).subscribe(data => {
            if (data.status) {
              this.toastrService.success(CommonMessages.statusUpdated);
              this.ngxSpinnerService.hide();
            }
          }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
          });





          
        }
      }).catch(() => {
        event.source.checked = !event.source.checked;
       // console.log(CommonMessages.dialogDismissMessage)
      });
  }
  clickEvent() { }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-theme-import.csv`, 'addingThemeBulk')
      .then(data => {
      //  console.log(data);
        self.getContacttype();
      })
      .catch(err => {
        console.error(err);
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_contact_type_tbl"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }
}

